module.exports = __webpack_public_path__ + "img/orbit-homepage-background-mobile.5abeb9b6.png";